
export const trackEvent = (eventData) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);

  console.log("Tracking Event:", eventData);
};
